import { useState } from 'react';

const testimonials = [
  {
    quote: "We were going through a difficult divorce and needed to sell quickly without the stress of open homes and agents. ReadyBuyer Group came to us within two days, gave us a fair written offer, and we settled in three weeks. It was the easiest part of an incredibly hard time.",
    name: 'Margaret T.',
    location: 'Bentleigh East, VIC',
    situation: 'Property Settlement',
    initials: 'MT',
  },
  {
    quote: "Mum was moving into a care home and we needed to sell her house without putting her through the disruption of inspections and a long campaign. The team was respectful, professional, and moved at exactly the pace we needed. We had an offer in four days.",
    name: 'David & Karen L.',
    location: 'Reservoir, VIC',
    situation: 'Moving to Care',
    initials: 'DL',
  },
  {
    quote: "I'd been sitting on an investment property that needed work and wasn't sure how to sell it without spending a fortune on renovations first. ReadyBuyer assessed it as-is and made a realistic offer. No staging, no agent fees, no drama. Exactly what I needed.",
    name: 'James R.',
    location: 'Footscray, VIC',
    situation: 'Investment Property',
    initials: 'JR',
  },
];

export default function TestimonialsSection() {
  const [active, setActive] = useState(0);

  return (
    <section className="py-20 md:py-28 bg-gray-950 text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-16">

        {/* Header */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16">
          <div className="lg:col-span-5">
            <span className="inline-block text-xs font-bold uppercase tracking-[0.2em] text-teal-400 mb-5">
              Real Stories
            </span>
            <h2 className="text-4xl md:text-5xl font-extrabold leading-tight">
              Vendors who<br />chose certainty<br />
              <span className="text-teal-400">over waiting.</span>
            </h2>
          </div>
          <div className="lg:col-span-7 flex items-end">
            <p className="text-gray-400 text-xl leading-relaxed">
              Every property has a story behind it. We work with sellers in all kinds of situations — and our job is to make the process as simple and stress-free as possible.
            </p>
          </div>
        </div>

        {/* Testimonial cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
          {testimonials.map((t, i) => (
            <button
              key={i}
              onClick={() => setActive(i)}
              className={`text-left p-8 rounded-2xl border transition-all duration-300 cursor-pointer ${
                active === i
                  ? 'bg-teal-700 border-teal-600'
                  : 'bg-white/5 border-white/10 hover:bg-white/10'
              }`}
            >
              {/* Stars */}
              <div className="flex gap-1 mb-5">
                {[...Array(5)].map((_, s) => (
                  <div key={s} className="w-4 h-4 flex items-center justify-center">
                    <i className={`ri-star-fill text-sm ${active === i ? 'text-yellow-300' : 'text-teal-500'}`}></i>
                  </div>
                ))}
              </div>

              <p className={`text-base leading-relaxed mb-6 ${active === i ? 'text-white' : 'text-gray-400'}`}>
                &ldquo;{t.quote}&rdquo;
              </p>

              <div className="flex items-center gap-3 mt-auto">
                <div className={`w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0 text-sm font-bold ${active === i ? 'bg-white/20 text-white' : 'bg-teal-700/30 text-teal-400'}`}>
                  {t.initials}
                </div>
                <div>
                  <div className={`font-semibold text-sm ${active === i ? 'text-white' : 'text-gray-200'}`}>{t.name}</div>
                  <div className={`text-xs ${active === i ? 'text-teal-200' : 'text-gray-500'}`}>{t.location}</div>
                </div>
                <span className={`ml-auto text-xs font-semibold px-3 py-1 rounded-full whitespace-nowrap ${active === i ? 'bg-white/20 text-white' : 'bg-white/5 text-gray-400'}`}>
                  {t.situation}
                </span>
              </div>
            </button>
          ))}
        </div>

        {/* Dot indicators */}
        <div className="flex justify-center gap-2">
          {testimonials.map((_, i) => (
            <button
              key={i}
              onClick={() => setActive(i)}
              className={`h-1.5 rounded-full transition-all duration-300 cursor-pointer ${active === i ? 'w-8 bg-teal-400' : 'w-4 bg-white/20 hover:bg-white/40'}`}
            />
          ))}
        </div>

        {/* Bottom stat strip */}
        <div className="mt-16 pt-12 border-t border-white/10 grid grid-cols-1 sm:grid-cols-3 gap-8 text-center">
          {[
            { val: '3–5', label: 'Days to written offer' },
            { val: '$0', label: 'Fees charged to sellers' },
            { val: '48hr', label: 'Offer validity window' },
          ].map((s) => (
            <div key={s.label}>
              <div className="text-4xl font-extrabold text-teal-400 mb-2">{s.val}</div>
              <div className="text-gray-400 text-sm uppercase tracking-widest">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
